<template>
  <v-list class="location-group-wrapper">
    <v-list-group
      v-for="(locationGroupType, index) in locationGroupTypes"
      :key="locationGroupType.type"
      :value="index === 0"
      class="primary"
    >
      <template v-slot:activator>
        <v-list-tile style="color:white;">
          <v-list-tile-content>
            <v-list-tile-title>
              <span>{{ locationGroupType.name }}</span>
              <v-chip color="green" text-color="white" class="count-icon"
                >{{ locationGroupType.groupList.length }}
              </v-chip>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <LocationGroup
        v-if="locationGroupType.groupList"
        :group-list="locationGroupType.groupList"
        :location-group-type="locationGroupType.type"
        :has-edit-permission="hasEditPermission"
        :geocoder="geocoder"
        :can-add-group="canAddGroup"
        :owner-profile-id="ownerProfileId"
        :hasGroupAddPermission="hasGroupAddPermission"
        @targetGroupType="handleTargetGroupType"
        class="expanded-contents"
      />
    </v-list-group>
  </v-list>
</template>

<script>
import LocationGroup from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/LocationGroup/LocationGroup'
import { getters, actions } from '@/vuex/modules/pointGroupOperation/constants'
import { locationGroupType } from '../constants'

export default {
  name: 'LocationGroupList',
  components: {
    LocationGroup,
  },
  props: {
    hasEditPermission: {
      type: Boolean,
      default: false,
    },
    geocoder: {
      type: Function,
      required: true,
    },
    canAddGroup: {
      type: Boolean,
      default: false,
    },
    hasGroupAddPermission: {
      type: Boolean,
      default: false,
    },
    ownerProfileId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    groupList() {
      return this.$store.getters[getters.groupList]
    },
    customLocationGroup() {
      return this.groupList.filter(
        group => group.locationType === locationGroupType.CUSTOM_LOCATION,
      )
    },
    poiLocationGroup() {
      return this.groupList.filter(
        group => group.locationType === locationGroupType.POI_LOCATION,
      )
    },
    locationGroupTypes() {
      return [
        {
          type: locationGroupType.CUSTOM_LOCATION,
          name: '地点個別指定',
          groupList: this.customLocationGroup,
        },
        {
          type: locationGroupType.POI_LOCATION,
          name: '地点カテゴリー',
          groupList: this.poiLocationGroup,
        },
      ]
    },
  },
  async created() {
    await this.$store.dispatch(actions.GET_GROUP_LIST, {
      ownerProfileId: this.ownerProfileId,
    })
  },
  methods: {
    handleTargetGroupType(targetGroupType) {
      this.$emit('targetGroupType', targetGroupType)
    },
  },
}
</script>

<style scoped lang="scss">
.location-group-wrapper {
  height: 100%;
  padding: 0;
}
.expanded-contents {
  height: 100%;
}
.count-icon {
  height: 20px;
  line-height: 20px;
  margin-left: 10px;
}

/* vuetify override */
.v-list__group--active {
  height: 94%;
}
::v-deep .v-list__group__items {
  height: 93%;
}
@media (max-height: 860px) {
  .v-list__group--active {
    height: 92%;
  }
  ::v-deep .v-list__group__items {
    height: 91%;
  }
}
</style>
